/* eslint-disable */
export const deleteStrategyBotConstants = {
    FETCH_DELETE_STRATEGY_BOT_REQUEST: 'FETCH_DELETE_STRATEGY_BOT_REQUEST',
    FETCH_DELETE_STRATEGY_BOT_SUCCESS: 'FETCH_DELETE_STRATEGY_BOT_SUCCESS',
    FETCH_DELETE_STRATEGY_BOT_FAILURE: 'FETCH_DELETE_STRATEGY_BOT_FAILURE',
};
